var s = (e, t, o) => new Promise((g, r) => {
  var u = (n) => {
    try {
      i(o.next(n));
    } catch (a) {
      r(a);
    }
  }, y = (n) => {
    try {
      i(o.throw(n));
    } catch (a) {
      r(a);
    }
  }, i = (n) => n.done ? g(n.value) : Promise.resolve(n.value).then(u, y);
  i((o = o.apply(e, t)).next());
});
import { selfAxios as m } from "@oppein/op-utils";
function f(e) {
  return s(this, null, function* () {
    const { data: t } = yield m.get(
      "/ucenterapi/anonymous/internal/region/getRegionByIdToAnonymous",
      { params: e }
    );
    return t;
  });
}
export {
  f as getRegionByIdToAnonymous
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/ucenterapi/anonymous/internal/region/getRegionByIdToAnonymous/get.js
// module id = 1832
// module chunks = 67